import React, { forwardRef } from 'react';
import { createPortal } from 'react-dom';

// This module exports a default component which will create a portal and attach it to a
// div with an id of `portal-root`.
//
// There is also a factory function exported createPortalComponent) which will provide the possibility
// to create a new element to attach the portal to.
// This becomes useful when you want to render portal(s) in different container(s) which will be
// created at runtime, so you don't have to change your template file.

/**
 * takes the container as a first argument and if that exists, it will attach the portal to it
 */
const withPortal = (elm) => elm
  && forwardRef(({ children, ...props }, ref) => createPortal(
    <div ref={ref} {...props}>
      {children}
    </div>,
    elm
  ));

/**
 * exported factory function for creating portal components inside explicit containers
 */
export const createPortalComponent = (id) => {
  // check if the container is already attached to the DOM
  // and if not, create and attach it
  let portalRoot = document.getElementById(id);
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.id = id;

    document.body.appendChild(portalRoot);
  }

  // return the new Portal component
  return withPortal(portalRoot);
};

/**
 * default Portal component, with a predefined container.
 * this will still create and attach the container if it doesn't exist.
 */
export default withPortal(document.getElementById('portal-root'));
